import { Fragment, useState, useCallback } from "react";

import classes from "./RecipeBookClosed.module.css";

import RecipeBookOpen from "../RecipeBookOpen/RecipeBookOpen";

// Component for book sitting on shelf
const RecipeBookClosed = (props) => {
  const [bookIsOpen, setBookIsOpen] = useState(false);

  // open the book -> RecipeBookOpen will show on screen
  const openBookHandler = useCallback(() => {
    setBookIsOpen(true);
  }, []);

  // remove RecipeBookOpen from screen
  const closeBookHandler = useCallback(() => {
    setBookIsOpen(false);
  }, []);


  // each component visually represented by book end
  return (
    <Fragment>
      {bookIsOpen && (
        <RecipeBookOpen book={props.book} onClose={closeBookHandler} />
      )}
      <div
        style={{
          top: props.posY,
          left: props.posX,
          backgroundColor: props.book.colour,
        }}
        className={classes.book}
        onClick={openBookHandler}
      >
        <div className={classes.abv}>{props.book.abrev}</div>
      </div>
    </Fragment>
  );
};

export default RecipeBookClosed;
